// rates
export const GET_RATES_SUCCESS = 'GET_RATES_SUCCESS';
export const GET_RATES_FAILURE = 'GET_RATES_FAILURE';
export const GET_RATES_REQUEST = 'GET_RATES_REQUEST';
export const CLEAR_RATES = 'CLEAR_RATES';

// rate
export const SELECT_RATE = 'SELECT_RATE';
export const CLEAR_SELECTED_RATE = 'CLEAR_SELECTED_RATE';

// pagination
export const SET_RATES_SEARCH = 'SET_RATES_SEARCH';
export const SET_RATES_PAGE_SIZE = 'SET_RATES_PAGE_SIZE';
export const NEXT_RATES_PAGE = 'NEXT_RATES_PAGE';
export const PREV_RATES_PAGE = 'PREV_RATES_PAGE';
